<template>
    <div :class="['list-item', classes]" v-if="['html', 'text'].includes(type)">
        <div v-html="item.html || item.label" />
    </div>
    <ul v-else-if="type === 'enumIcons'" :class="['sub-list', classes]">
        <li v-for="(subitem, index) in item.subItems" class="sub-list__item" :key="index">
            <component
                class="sub-list__item--link"
                :is="subitem.link ? 'a' : 'div'"
                :href="subitem.link || null"
                :rel="classes === '--social-media' ? 'nofollow' : null"
            >
                <img :src="subitem.image" :alt="subitem.label" />
                <span v-if="subitem.label">
                    {{ subitem.label }}
                </span>
            </component>
        </li>
    </ul>
</template>

<script>
import parseFooterItemHandler from '@/themes/novaporta/mixins/parse-footer-item-handler';

export default {
    name: 'ContactsContent',
    mixins: [parseFooterItemHandler]
};
</script>

<style lang="scss" scoped>
@import '../../../context.scss';
</style>
